import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import "@enersis/gp-components/gp-textarea";
import { TextareaComponent } from "./textarea.component";

@NgModule({
  declarations: [TextareaComponent],
  imports: [CommonModule, ReactiveFormsModule, A11yModule],
  exports: [TextareaComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TextareaModule {}
